var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicLayoutWrapper',{staticClass:"template-renderer",attrs:{"template":_vm.template,"questions":_vm.questions,"document-value":_vm.content,"value":_vm.content}})}
var staticRenderFns = []

export { render, staticRenderFns }